import React, { isValidElement, memo, ReactElement, useContext } from 'react';
import { TabsContext } from 'src/modules/common/components/Tabs';

type TabPanelsProps = {
  children: ReactElement[];
};

export const TabPanels = memo(({ children }: TabPanelsProps) => {
  const { activeTab } = useContext(TabsContext);

  return (
    <>
      {React.Children.map(children, (child, index) => isValidElement(child) && index === activeTab &&
      React.cloneElement(child))}
    </>
  );
});
